import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=10cff082&"
import script from "./DocumentType.vue?vue&type=script&lang=js&"
export * from "./DocumentType.vue?vue&type=script&lang=js&"
import style0 from "./DocumentType.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports